<section class="sort-section">
    <h4 i18n="@@sort-selector-heading">Sorting</h4>
    <mat-radio-group
        [(ngModel)]="sorting"
        (change)="selectionChanged()"
        aria-label="Select sort direction"
        i18n-
        aria-label="@@sort-selector-label">
        @for (sort of sortDefs; track sort; let i = $index) {
        <mat-radio-button [checked]="sort.id === sorting()" value="{{ sort.id }}">{{ sort.text }}</mat-radio-button>
        }
    </mat-radio-group>
</section>
